(function() {
    'use strict';

    angular.module('allegro').controller('AccountListController', AccountListController);

    AccountListController.$inject = [
        '$scope',
        '$state',
        '$interval',
        'notificationSrvc',
        'errorNotificationSrvc',
        'filterQuerySrvc',
        'datatableDefaultPageSizeValueConst',
        'checkSearchSrvc',
        'allegroAccountDataSrvc',
        'allegroConfigDataSrvc',
        'allegroConfigMessagesConst',
        'allegroSrvc',
        'checkModelPermissionsSrvc',
        'allegroAccountPermissionsConst'
    ];

    function AccountListController(
        $scope,
        $state,
        $interval,
        notificationSrvc,
        errorNotificationSrvc,
        filterQuerySrvc,
        datatableDefaultPageSizeValueConst,
        checkSearchSrvc,
        allegroAccountDataSrvc,
        allegroConfigDataSrvc,
        allegroConfigMessagesConst,
        allegroSrvc,
        checkModelPermissionsSrvc,
        allegroAccountPermissionsConst
    ) {
        var self = this;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        // Data
        self.modelRows = [];
        self.loading = false;
        self.accountIntervals = {};

        // Methods
        self.getAccounts = getAccounts;
        self.getAccountDeviceCode = getAccountDeviceCode;
        self.revokeAccountAccessToken = revokeAccountAccessToken;
        self.getAccountAuthInfo = getAccountAuthInfo;
        self.refreshAccountAuthInfo = refreshAccountAuthInfo;

        // Model Permissions Check
        self.hasAccountViewPerm  = hasAccountViewPerm;
        self.hasAccountCreatePerm = hasAccountCreatePerm;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getAccounts();
        }

        function getAccounts(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                };
            }
            return allegroAccountDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.modelRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getAccounts);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function getAccountDeviceCode(account){
            if (!account.configuration){
                notificationSrvc.notification("error", allegroConfigMessagesConst.noConfigurationError);
                return;
            }

            account.loadingDeviceCode = true;

            return allegroConfigDataSrvc.getDeviceFlow({pk: account.configuration.pk}).$promise.then(
                function(response) {
                    account.configuration.device_flow = response;
                    self.refreshAccountAuthInfo(account, 5000);
                    notificationSrvc.notification("success", allegroConfigMessagesConst.createDeviceFlowSuccess);
                    return response;
                },
                function(response) {
                    if (response.status === 400){
                        errorNotificationSrvc.displayErrors(response.data);
                    } else {
                        notificationSrvc.notification("error", allegroConfigMessagesConst.error);
                    }
                }
            ).finally(
                function(response) {
                    account.loadingDeviceCode = false;
                    return response;
                }
            );
        }

        function getAccountAuthInfo(account){
            var configurationId = account.configuration.pk;

            return allegroConfigDataSrvc.getAuthInfo({pk: configurationId}).$promise.then(
                function (response) {
                    var device_flow = response.device_flow;
                    var access_token = response.access_token;
                    var revoked_token = response.revoked_token;

                    account.configuration.device_flow = device_flow;
                    account.configuration.access_token = access_token;

                    if (!device_flow && !access_token && revoked_token){
                        var revoke_reason_code = revoked_token.revoke_reason_code;
                        if (revoke_reason_code === 'email_verification_failed') {
                            notificationSrvc.notification("error", allegroConfigMessagesConst.revokedTokenInvalidEmailError);
                        } else if (revoke_reason_code === 'account_id_verification_failed') {
                            notificationSrvc.notification("error", allegroConfigMessagesConst.revokedTokenInvalidAccountIdError);
                        }

                        account.loadingAccessToken = false;
                        $interval.cancel(self.accountIntervals[configurationId]);
                        delete self.accountIntervals[configurationId];
                        return response;
                    }

                    if (self.accountIntervals[configurationId] && access_token !== null){
                        account.loadingAccessToken = false;
                        $interval.cancel(self.accountIntervals[configurationId]);
                        delete self.accountIntervals[configurationId];
                        notificationSrvc.notification("success", allegroConfigMessagesConst.accessTokenRetriveSuccess);
                    }
                    return response;
                }
            )
        }

        function refreshAccountAuthInfo(account, timeout){
            if (!account.configuration){
                return null;
            }

            var configurationId = account.configuration.pk;
            var deviceFlow = account.configuration.device_flow;
            var accessToken = account.configuration.access_token;

            if (!deviceFlow || accessToken){
                return null;
            }

            account.loadingAccessToken = true;
            if (!self.accountIntervals[configurationId]) {
                self.accountIntervals[configurationId] = $interval(function() {
                    self.getAccountAuthInfo(account);
                }, timeout);
            }
        }

        function revokeAccountAccessToken(account){
            if (!account.configuration.access_token){
                notificationSrvc.notification("error", allegroConfigMessagesConst.accessTokenRevokeError);
                return;
            }

            var title = 'rozłączyć konto: ' + account.name;
            return allegroSrvc.revokeAccountToken(title, account.configuration.pk, function(response) {
                if (response.is_revoked){
                    account.configuration.access_token = null;
                    notificationSrvc.notification("success", allegroConfigMessagesConst.accessTokenRevokeSuccess);
                }
                return response;
            });
        }

        function hasAccountViewPerm(){
            return !checkModelPermissionsSrvc.isDenied(allegroAccountPermissionsConst.view);
        }

        function hasAccountCreatePerm(){
            return !checkModelPermissionsSrvc.isDenied(allegroAccountPermissionsConst.add);
        }
    }
})();
